import Swal from "sweetalert2";

export default function ErrorPopup(message, visibilityTime) {
	let timerInterval;
	return Swal.fire({
		position: "top",
		html: `
            <div class="uk-flex uk-flex-middle uk-flex-center">
                <span uk-icon="icon: ban; ratio: 2" class="uk-text-danger uk-margin-small-right"></span> <p class="uk-text-default">${message || "Błąd! Coś poszło nie tak..."}</p>
            </div>
        `,
		timer: visibilityTime || 2000,
		timerProgressBar: true,
		showConfirmButton: false,
		backdrop: false,
		willClose: () => {
			clearInterval(timerInterval);
		},
	});
}
